export const fixDateLog = (date) => {
  let yyy = date.getFullYear();
  let mm = '' + (date.getMonth() + 1);
  let dd = '' + date.getDate();
  if (mm.length < 2) mm = '0' + mm;
  if (dd.length < 2) dd = '0' + dd;
  return [yyy, mm, dd].join('-');
};

export const sameDayWplFixWhileAddingPost = (posts, date) => {
  let wpl = null;
  posts.map((post) => {
    if (post.date === date && post.wpl !== '') {
      wpl = post.wpl;
    } else if (post.date === date && post.wpl === '') {
      wpl = post.wpl;
    }
  });
  return wpl;
};

export const sameDayWorkingHFixWhileAddingPost = (posts, date) => {
  let wh = null;
  posts.map((post) => {
    if (post.date === date && post.workingh !== '') {
      wh = post.workingh;
    }
  });
  return wh;
};
